
import Vue from 'vue'
let showTimer = null
let delayTimer = null
let i = 0
export default {
  state: {
    types: [0],
    configState: false,
    fnMap: {},
    eventList: [' '],
    valueMap: {},
    dom: null
  },
  mutations: {
    getConfigDom(state) {
      state.dom = document.getElementsByClassName('option-config-util')[0]
    },
    refreshConfigState(state,payload = false) {
      state.configState = payload
    },
    setPopperConfig(state,payload) {
      state.eventList.push(`${payload.e} ${payload.c}`)
      const curr = state.eventList[state.eventList.length - 1].split(' ')
      const prev = state.eventList[state.eventList.length - 2].split(' ')
      if(prev && prev[0] === 'true' && curr[0] === 'false' && prev[1] !== curr[1]) {
      } else {
        clearTimeout(showTimer)
      }
      Vue.nextTick(() => {
        if(payload.e) {
          showTimer = setTimeout(() => {
            state.configState = true
            state.types = payload.t
            payload.t.forEach(key => {
              state.fnMap[key] = payload.fn
              state.valueMap[key] = payload.v
            })
            const poppers = document.getElementsByClassName(payload.c ? payload.c : 'configable')
            // console.log(poppers,'xxxxxxxxxx',state.dom)
            const popper = poppers[poppers.length - 1]
            popper.appendChild(state.dom)
          },200) 
        }
      })
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/popperConfig.js